import React, { useState } from 'react';
import Timer from './Timer';
import SessionForm from './SessionForm';
import SessionList from './SessionList';
import { startSession, endSession, listSessions } from '../api/session';

export default function MainDashboard() {
  const [activeTab, setActiveTab] = useState('timer');
  const [session, setSession] = useState(null);
  const [timerSeconds, setTimerSeconds] = useState(0);
  const [showTimer, setShowTimer] = useState(false);
  const [notes, setNotes] = useState('');
  const [sessions, setSessions] = useState([]);

  React.useEffect(() => {
    listSessions().then(setSessions).catch(() => setSessions([]));
  }, []);

  const handleStart = async (goal, seconds) => {
    try {
      const s = await startSession(goal, seconds);
      setSession(s);
      setTimerSeconds(s.target_duration_seconds || seconds);
      setShowTimer(true);
    } catch {
      alert('Failed to start session');
    }
  };

  const handleStop = async () => {
    if (!session) return;
    try {
      await endSession(session.id, false, notes);
      setShowTimer(false);
      setSession(null);
      setNotes('');
      const updated = await listSessions();
      setSessions(updated);
    } catch {
      alert('Failed to end session');
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '40px auto', background: '#fff', borderRadius: 16, boxShadow: '0 2px 24px #eee', padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
        <button
          onClick={() => setActiveTab('timer')}
          style={{ padding: '10px 32px', borderRadius: 8, border: 'none', background: activeTab === 'timer' ? '#2d7d46' : '#eee', color: activeTab === 'timer' ? '#fff' : '#222', fontWeight: 600, fontSize: '1.1em', marginRight: 8 }}
        >
          Timer
        </button>
        <button
          onClick={() => setActiveTab('dashboard')}
          style={{ padding: '10px 32px', borderRadius: 8, border: 'none', background: activeTab === 'dashboard' ? '#2d7d46' : '#eee', color: activeTab === 'dashboard' ? '#fff' : '#222', fontWeight: 600, fontSize: '1.1em' }}
        >
          Dashboard
        </button>
      </div>
      {activeTab === 'timer' ? (
        <div>
          {showTimer ? (
            <Timer targetSeconds={timerSeconds} onComplete={() => {}} onStop={handleStop} />
          ) : (
            <SessionForm onStart={handleStart} disabled={!!session} />
          )}
          <textarea
            placeholder="Notes (optional)"
            value={notes}
            onChange={e => setNotes(e.target.value)}
            style={{ width: '100%', marginTop: 16, borderRadius: 8, border: '1px solid #ccc', padding: 8 }}
          />
        </div>
      ) : (
        <div>
          <SessionList sessions={sessions} />
        </div>
      )}
    </div>
  );
}
